module.exports = __webpack_public_path__ + "fonts/Jost-Light.716ee74.ttf";